var HubspotChatService = /** @class */ (function () {
    function HubspotChatService() {
    }
    HubspotChatService.isApiReady = false;
    HubspotChatService.onConversationsAPIReady = function () {
        HubspotChatService.isApiReady = true;
        // console.log(`HubSpot Conversations API: ${window.HubSpotConversations}`);
        HubspotChatService.loadWidget();
    };
    HubspotChatService.init = function () {
        if (window.HubSpotConversations) {
            HubspotChatService.onConversationsAPIReady();
        }
        else {
            /*
              Otherwise, callbacks can be added to the hsConversationsOnReady on the window object.
              These callbacks will be called once the external API has been initialized.
            */
            window.hsConversationsOnReady = [function () { return HubspotChatService.onConversationsAPIReady(); }];
        }
    };
    HubspotChatService.loadWidget = function () {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.widget.load();
    };
    HubspotChatService.refreshWidget = function (newThread) {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.widget.refresh({ openToNewThread: newThread });
    };
    HubspotChatService.openWidget = function () {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.widget.open();
    };
    HubspotChatService.closeWidget = function () {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.widget.close();
    };
    HubspotChatService.removeWidget = function () {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.widget.remove();
    };
    HubspotChatService.clearWidget = function (reset) {
        if (!HubspotChatService.isApiReady)
            return;
        window.HubSpotConversations.clear({ resetWidget: reset });
    };
    return HubspotChatService;
}());
export { HubspotChatService };
